<template>
  <Container class="container-sm-none">
    <Progressbar :step="3" :step-count="model.stepCount">
      Enter Your Contact Details
    </Progressbar>
    <Card class="card-shadow">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">
          <h3 class="heading-3 weight-medium pb-10 pb-md-16 text-left text-md-center">
            Enter Your Contact Details
            <Tooltip>
              <p class="text-left m-0">
                
    We need your <b>phone number</b> to contact you more quickly should there be any errors
    or a need for additional information in your application.
    <br/>
    <br/>
    We need your <b>e-mail</b> so that you can save your application progress, and later reopen
    and complete it via the link we will send you.
  
              </p>
            </Tooltip>
          </h3>

          <div class="input-box-holder" v-validate="errors" v-has-value="model.insurer.phone">
            <TextField
              class="input-box"
              title='Phone number'
              description='Required Format +421 911 111 111'
              v-phone-format
              @change="setPhoneNumber"
              :value="model.insurer.phone"
              :max-length="16"
              required
            />
            <div class="validation-output text-left mt-1">
              <ErrorHandler class="error" id="V007">
                Enter your phone number.
              </ErrorHandler>

              <ErrorHandler class="error" id="V008">
                Enter the phone number in the correct format.
              </ErrorHandler>

              <ErrorHandler class="error" id="V1042">
                Nepovolené telefónne číslo. Zadajte iné.
              </ErrorHandler>
            </div>
          </div>

          <div class="input-box-holder" v-validate="errors" v-has-value="model.insurer.email">
            <TextField
              class="input-box mt-4"
              title='E-mail'
              @change="setEmail"
              :value="model.insurer.email"
              required
            />
            <div class="validation-output text-left mt-2">
              <ErrorHandler class="error" id="V009">
                Enter your e-mail.
              </ErrorHandler>

              <ErrorHandler class="error" id="V010">
                Enter your e-mail in the correct format.
              </ErrorHandler>

              <ErrorHandler class="error" id="V011">
                The maximum number of characters is 50.
              </ErrorHandler>
            </div>
          </div>

          <p :class="['mt-10', 'body-3', 'weight-regular', 'tf-container']">
            
     By providing my phone number and e-mail, I agree to be contacted by your specialist agent
     to finish the process of completing my application within 14 days.
  
          </p>

          <ButtonGroup class="pt-20">
            <Button
              class="btn-outline-tertiary w-full"
              :icon-left="require('@/assets/svg/icon-left-gray.svg')"
              @click="redirectBack"
            >
              Back
            </Button>
            <Button
              class="btn-primary w-full"
              :icon-right="require('@/assets/svg/icon-right-white.svg')"
              @click="redirectToNext"
              v-scroll-to-error
            >
              Continue
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Card from '@/components/Card/Card.vue';
import TextField from '@/components/TextField/TextField.vue';
import Button from '@/components/Button/Button.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import distributionChannels from '@/mixins/distributionChannels';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import routes from '@/mixins/routes';
import lead from '@/mixins/lead';
import GA from '@/mixins/GA';
import debounce from 'union_address/debounce';

export default {
  name: 'ContactInfoPage',
  mixins: [lead, distributionChannels, routes, GA],
  components: {
    ButtonGroup,
    Button,
    TextField,
    Card,
    Container,
    ErrorHandler,
    Progressbar,
    Tooltip,
  },
  props: {
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  methods: {
    /*
    * If we still haven't delivery phone.
    * Then after entering valid phone copy this phone to delivery class.
    * */
    setPhoneNumber(phone) {
      this.model.insurer.phone = phone.trim().replace(/\s+/g, ' ');
      this.model.delivery.phone = this.model.insurer.phone ? this.model.insurer.phone : null;
    },
    /*
    * If we still haven't delivery email.
    * Then after entering valid email copy this email to delivery class.
    * */
    setEmail(email) {
      this.model.insurer.email = email.replace(/\s+/g, '');
      this.model.delivery.email = this.model.insurer.email ? this.model.insurer.email : null;
    },
    redirectToNext() {
      if (this.errors.length === 0) {
        this.saveLead(this.getNearestNextAvailableStep());
        // netusim co som tu chcel spravit, podla mna tu mam chybu, tu ma byt podla mna podmienka ktora hovori:
        // ak sa tento krok nenachadza vo visitedSteps danej osoby...
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
          // ... tak ho tam pridaj
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
        }
        // inkrementuj currentPersonStepIndex
        this.model.currentPersonStepIndex += 1;
        // NA OSTATNYCH KROKOCH JE TO V PODSTATE COPY PASTE!!!
        this.$router.goToStep(this.getNearestNextAvailableStep());
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
    async debouncedValidatePhoneApi() {
      debounce(this.validatePhoneApi(), 300);
    },
    async validatePhoneApi() {
      const checkPhoneRequest = {
        phoneNumber: this.model.insurer.phone,
        brokerCode: this.model.broker.number,
      };
      try {
        const response = await this.$axios.post('uzp_api/japi/IVerificationApi/checkPhoneNumber', [checkPhoneRequest]);
        this.model.isPhoneNumberAllowed = response.data.valid;
        this.model.overenieMediform = true;
      } catch (e) {
        console.error(e);
        this.model.isPhoneNumberAllowed = null;
        this.model.overenieMediform = false;
      }
    },
  },
  created() {
    this.model.step = 4;
    if (this.model.lastStep < 4) this.model.lastStep = 4;
  },
  mounted() {
    this.funnelStep('Kontaktné údaje');
  },
  watch: {
    errors: {
      async handler(newErrors) {
        const hasPhoneErrors = newErrors.some(
          (error) => error === 'V007' || error === 'V008',
        );

        if (!hasPhoneErrors) {
          await this.debouncedValidatePhoneApi();
        }
      },
    },
    'model.insurer.phone': {
      handler(newPhone) {
        if (newPhone) {
          this.model.overenieMediform = null;
          this.model.isPhoneNumberAllowed = null;
        }
      },
    },
  },
};
</script>
